import { useContext } from "react";
import checkoutContext from "../../../../checkout-context";
import { CompanyDetails } from "../../types/Types";
import { FormField } from "../fields/FormField";
import { CountrySelect } from "../fields/CountrySelect";
import { getAddressDetailsEvent, getCocDetailsEvent } from "../formPrefills";

type CompanyDetailsFormProps = { defaultValues: Partial<CompanyDetails> };

export function CompanyDetailsForm({
  defaultValues = {},
}: CompanyDetailsFormProps) {
  const { textsMapping, addressEndpointUrl, cocEndpointUrl } =
    useContext(checkoutContext);
  const prefillAddresDetails = getAddressDetailsEvent(addressEndpointUrl);
  const prefillCocDetails = getCocDetailsEvent(cocEndpointUrl);

  return (
    <>
      <FormField
        name="invoiceId"
        defaultValue={defaultValues?.invoiceId}
        type="hidden"
      />
      <FormField
        name="companyInvoiceEmail"
        defaultValue={defaultValues?.companyInvoiceEmail}
        type="hidden"
      />

      <FormField.Section
        title={textsMapping.billingDataCompanyTitle}
        description={textsMapping.billingDataCompanyText}
      >
        <FormField
          name="chamberOfCommerce"
          defaultValue={defaultValues?.chamberOfCommerce}
          label={textsMapping.companyDetailsChamberOfCommerceLabel}
          placeholder={textsMapping.companyDetailsChamberOfCommercePlaceholder}
          onBlur={prefillCocDetails}
        />

        <FormField
          name="name"
          defaultValue={defaultValues?.name}
          label={textsMapping.companyDetailsNameLabel}
          placeholder={textsMapping.companyDetailsNamePlaceholder}
          required
        />

        <CountrySelect defaultValues={defaultValues?.address} />
        <FormField
          name="address.zip"
          defaultValue={defaultValues?.address?.zip}
          label={textsMapping.homeAddressZipLabel}
          placeholder={textsMapping.homeAddressZipPlaceholder}
          onBlur={prefillAddresDetails}
          required
        />
        <FormField.Group>
          <FormField
            name="address.houseNumber"
            type="number"
            defaultValue={defaultValues?.address?.houseNumber}
            label={textsMapping.homeAddressHouseNumberLabel}
            placeholder={textsMapping.homeAddressHouseNumberPlaceholder}
            onBlur={prefillAddresDetails}
            required
          />
          <FormField
            name="address.houseNumberAddition"
            defaultValue={defaultValues?.address?.houseNumberAddition}
            label={textsMapping.homeAddressHouseNumberAdditionLabel}
            placeholder={textsMapping.homeAddressHouseNumberAdditionPlaceholder}
          />
        </FormField.Group>
        <FormField
          name="address.street"
          defaultValue={defaultValues?.address?.street}
          label={textsMapping.homeAddressStreetLabel}
          placeholder={textsMapping.homeAddressStreetPlaceholder}
          required
        />
        <FormField
          name="address.city"
          defaultValue={defaultValues?.address?.city}
          label={textsMapping.homeAddressLocationLabel}
          placeholder={textsMapping.homeAddressLocationPlaceholder}
          required
        />
      </FormField.Section>

      <FormField.Section
        title={textsMapping.billingDataCompanyContactTitle}
        description={textsMapping.billingDataCompanyContactText}
      >
        <FormField
          name="companyContactEmail"
          type="email"
          defaultValue={defaultValues?.companyContactEmail}
          label={textsMapping.companyDetailsContactEmailLabel}
          placeholder={textsMapping.companyDetailsContactEmailPlaceholder}
          invalidMessage={textsMapping.inputErrorMessageEmail}
          required
        />
        <FormField
          name="companyContactPhone"
          defaultValue={defaultValues?.companyContactPhone}
          label={textsMapping.companyDetailsContactPhoneLabel}
          placeholder={textsMapping.companyDetailsContactPhonePlaceholder}
          required
        />
      </FormField.Section>
    </>
  );
}
